export enum SkillPracticeCategory {
  Inactive,
  JustStarting,
  Stuck,
  PracticeMakesPerfect,
  ReadyForChallenge
}
